import { returnOrUpdate } from 'ol/extent';
import Config from '../../Config';
export class chatBubble {
  constructor(isOpen, isVisible) {
    this.isOpen = isOpen;
    this.isVisible = isVisible;
  }
 

   getMaxZIndex() {
    return Math.max(
      ...Array.from(document.querySelectorAll('body *'), el =>
        parseFloat(window.getComputedStyle(el).zIndex),
      ).filter(zIndex => !Number.isNaN(zIndex)  ),
      0,
    );
  }
  buildScriptMainBtn(){ 
        var script = document.createElement("script");
        script.setAttribute("type", "text/javascript");
        script.setAttribute("defer", "defer");
        script.id = "ChatBubbleScript"
        script.text = `
        function toggleChatBubble(div) {
          try {
                  const chatBubble = document.getElementsByClassName("chatBubble")[0];
                  const body = document.getElementsByTagName('body')[0];
                  if (chatBubble.classList.contains('open')) {
                    chatBubble.classList.remove("open");
                    body.style.overflow = "auto";
                    //ga('contact_us_new', 'click', "open");
                    ga('send', 'event', 'contact_us_new', 'click', 'open');

                  }
                  else {
                    //ga('contact_us_new', 'click', "close");
                    ga('send', 'event', 'contact_us_new', 'click', 'close');
                    chatBubble.classList.add("open");
                    body.style.overflow = "hidden";
                  }
          }
          catch {
                  body.style.overflow = "auto";
          }
        }

      function clickTestBubble(nameBubble) {
          try {
           // gaEvent('contact_us_new', 'click', 'gfdgfr'+nameBubble);
          // ga('contact_us_new', 'click', nameBubble)
          ga('send', 'event', 'contact_us_new', 'click', nameBubble);
          }
          catch {
          }
        }
                 
                  `;
        document.getElementsByTagName("head")[0].appendChild(script);
}

  buildMainBtn(chatBubbleItemArr, divChatBubble, hideChatBox) {
    try{
          
            this.hideMainBtnChat(divChatBubble, hideChatBox);
            if(hideChatBox ==true){
                return;
          }
          if(!(document.getElementById("imgMainBtnBubbleOpen")))
          {
            this.buildScriptMainBtn();
            var imgMainBtnBubbleChatOpenSrc =   JSON.parse(Config.imgMainBtnBubbleChatOpen);
            var imgMainBtnBubbleChatCloseSrc =   JSON.parse(Config.imgMainBtnBubbleChatClose);

            var imgMainBtnBubbleClose = document.createElement('img');
            imgMainBtnBubbleClose.src = Config.epiBaseUrl + imgMainBtnBubbleChatCloseSrc?.url;
            imgMainBtnBubbleClose.classList.add("img-btn-x");
            imgMainBtnBubbleClose.id = "imgMainBtnBubbleClose";


            var imgMainBtnBubbleOpen = document.createElement('img');
            imgMainBtnBubbleOpen.src = Config.epiBaseUrl + imgMainBtnBubbleChatOpenSrc?.url;
            imgMainBtnBubbleOpen.classList.add("img-btn-chat");
            imgMainBtnBubbleOpen.id = "imgMainBtnBubbleOpen";

            divChatBubble.appendChild(imgMainBtnBubbleClose);
            divChatBubble.appendChild(imgMainBtnBubbleOpen);
          }
       }
       catch{}
    }
  
    hideMainBtnChat(divChatBubble, hideMainBtnChat) {
      try{
            if(hideMainBtnChat == true)
            {
              divChatBubble.style.visibility = "hidden";
            }
              else {
                divChatBubble.style.visibility = "visible";
              }
            }
        
         catch{}
      }
  buildItemChatBubbleUp(chatBubbleItemArr, divChatBubble) {
    try{
        if (chatBubbleItemArr == "") {return};
        var BubbleGroupContainer = document.getElementById("BubbleGroupContainer")
        if(BubbleGroupContainer){
          BubbleGroupContainer.remove();
        }

          var BubbleGroupContainer = document.createElement('div');
          BubbleGroupContainer.width = "120";
          BubbleGroupContainer.height = "49"* chatBubbleItemArr.length;
          BubbleGroupContainer.classList.add("bubble-group-container");
          BubbleGroupContainer.id = "BubbleGroupContainer";

          for (var i = 0, j = 2; i < chatBubbleItemArr.length; i++, j--) {
            
              var BubbleContainer = document.createElement('div');
              var BubbleContactUsDiv = document.createElement('div');
              var BubbleImgHref = document.createElement('a');
              var BubbleImg = document.createElement('img');
              var BubbleHrefContainer = document.createElement('div');
              var BubbleHref = document.createElement('a');

            //var maxZIndex = this.getMaxZIndex() + 1;
            divChatBubble.style.zIndex = 99999;

              //BubbleImg
              BubbleImg.src = Config.epiBaseUrl + chatBubbleItemArr[i].bubbleIcon?.value?.url;
              BubbleImg.alt = chatBubbleItemArr[i].headerText?.value;
          
              //BubbleImgHref
              BubbleImgHref.href = chatBubbleItemArr[i].link?.value;
              BubbleImgHref.target = "_blank";
              BubbleImgHref.appendChild(BubbleImg);
              //BubbleContactUsDiv
              BubbleContactUsDiv.classList.add("bubble-contact-us-div");
              BubbleContactUsDiv.appendChild(BubbleImgHref);
              //BubbleHref
              BubbleHref.href = chatBubbleItemArr[i].link?.value;
              BubbleHref.target = "_blank";
              BubbleHref.text = chatBubbleItemArr[i].headerText?.value;
              //BubbleHrefContainer
              BubbleHrefContainer.appendChild(BubbleHref);
              BubbleHrefContainer.classList.add("bubble-href-text");
              //BubbleContainer
              BubbleContainer.classList.add("bubble-container");
              BubbleContainer.id = "btn_"+BubbleImg.alt;
              BubbleContainer.onclick = function() { clickTestBubble(this.id); };
              BubbleContainer.appendChild(BubbleContactUsDiv);
              BubbleContainer.appendChild(BubbleHrefContainer);

           //   BubbleContainer.style.bottom = (i * 50) + "px";
           //   BubbleContainer.style.left = "30px";
              BubbleGroupContainer.appendChild(BubbleContainer);
          }
          divChatBubble.appendChild(BubbleGroupContainer);
    }
    catch{}
  }
 
}
  

    
